var plugin_rtlignore_default = {
  "alignLeft": "_5TVnw",
  "textWrapNowrap": "QFrlT",
  "alignRight": "bLXAO",
  "alignCenter": "XzRcS",
  "sizeFullWidth": "AgPJ-",
  "renderedInTable": "_4hOF4",
  "sizeOriginal": "c6kih",
  "sizeContent": "_0fdLB",
  "sizeSmall": "SCTLJ",
  "sizeSmallCenter": "C95TP",
  "flex": "jD52Y",
  "atomic": "KaA6n",
  "embed": "Z498h",
  "horizontalScrollbar": "Dr5dy",
  "pluginContainerMobile": "_1zeuP"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
